import { WizardFlow } from '@/components/wizard/WizardFlow';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 w-full">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
          <WizardFlow />
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
